import { SortDirection } from '../../../../utils/constants';
import { createSearchPageSlice } from '../../../Generic/SearchPage/slices/searchPageSlice';

export const filterFields = {
  CountryName: 'CountryName',
  Active: 'Active',
};

export const countrySliceName = 'countrySearch';

const countrySearchSlice = createSearchPageSlice({
  sliceName: countrySliceName,
  filterFields,
  initialFilterState: {
    CountryName: '',
    Active: true,
  },
  initialPageState: {
    page: 0,
    pageSize: 20,
    sortColumn: 'CountryCode',
    sortDirection: SortDirection.Asc,
  },
});

export const countrySearchActions = countrySearchSlice.actions;
export default countrySearchSlice.reducer;
